class InvalidTokenError extends Error {
  constructor(message) {
    super(message);
    this.name = 'InvalidTokenError';
    this.stack = new Error().stack;
  }
}

export default InvalidTokenError;
